import { request } from 'utils/requests'

// Quem está online agora e quando cada um foi visto
export const presencaEquipe = async () => (await request.get('/collaborator/presenca')).data
// Entrega de avisos (e-mail e push) de cada advogado — só administradores
export const entregaAvisos = async () => (await request.get('/collaborator/entrega-avisos')).data
// Foto de quem tem foto, por id (fica fora da listagem de colaboradores)
export const fotosEquipe = async () => (await request.get('/collaborator/fotos')).data
// Só quem está com o sistema aberto agora (nome, foto e cargo)
export const equipeOnline = async () => (await request.get('/collaborator/online')).data
export const desempenhoEquipe = async (mes) => (await request.get('/collaborator/desempenho', { params: mes ? { mes } : {} })).data
